import { IonCard, IonCardContent, IonCardHeader, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import Info from '../components/Info';
import './Tab4.css';

const TabInfo: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Protection des données</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Protection des données</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Info />
      </IonContent>
    </IonPage>
  );
};

export default TabInfo;
